<template>
    <div>
        <el-dialog
            title="房态详情"
            :visible.sync="showdialog"
            width="800px"
            :before-close="back">
            <div class="base-warp">
                <el-form :model="houseinfo" label-width="80px" :inline="false" size="mini">
                    <el-form-item label="日期">
                        <p class="text">{{date}}</p>
                    </el-form-item>
                    <el-form-item label="房源信息">
                        <p class="text link-text" @click="seehouse">{{houseinfo.name}}</p>
                    </el-form-item>
                    <el-form-item label="房东">
                        <p class="text link-text" @click="seelandlord">{{landlordInfo.name}}({{landlordInfo.telephone}})</p>
                    </el-form-item>
                    <el-form-item label="入住人数">
                        <p class="text">{{renternum}}</p>
                    </el-form-item>
                    <el-form-item label="房态数量">
                        <p class="text">{{states.length}}</p>
                    </el-form-item>
                    <el-form-item label="入住人">
                        <div class="state-box">
                            <div class="text link-text2" v-for="(item, index) in states" :key="index" @click="seestatedetail(item)">
                                <span class="stext renter">{{item.rentername}}</span>
                                <span class="stext date">入住时间： {{item.fromDate}}</span>
                                <span class="stext date">离店时间： {{item.toDate}}</span>
                                <span class="stext date">同行人数： {{item.renternum}}</span>
                                <span class="link-text">查看详情</span>
                                <span class="link-text el-icon-caret-right"></span>
                            </div>
                        </div>
                        
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: true,
            houseinfo: '',
            landlordInfo: '',
            landlordUid: '',
            states: [],
            date: '',
            renternum: 0,
        }
    },
    mounted () {
        var houseinfo = this.$route.query.houseinfo;
        var states = this.$route.query.states;
        this.houseinfo = JSON.parse(houseinfo);
        this.states = JSON.parse(states);
        this.date = this.$route.query.date
        this.landlordUid = this.houseinfo.landlord['$id'];
        this.renternum = this.$route.query.renternum
        this.getuserinfo();

    },
    methods: {
        getuserinfo() {
            var params = {
                userType: 'landlord',
                uids: this.$Base64.encode(this.landlordUid),
            }
            this.$api.getUserInfo(params)
                .then(data=>{
                    var  {userInfo} = data;
                    this.landlordInfo = userInfo;
                })
        },
        seestatedetail(item) {
            var hsid = item._id['$oid']
            this.$router.push({path: '/police/calendar/detail', query:{hsid}})
        },
        seehouse() {
            var id = this.houseinfo.id;
            this.$router.push({path: '/police/calendar/house', query:{hid: id}})
        },
        seelandlord() {
            var id = this.$Base64.encode(this.landlordUid);
            this.$router.push({path: '/police/calendar/landlord', query: {uid: id, type: 'landlord'}})
        },
        back() {
            this.$router.go(-1)
        }
    },
}
</script>

<style lang="scss" scoped>
.state-box{
    .link-text2{
        border-bottom: 1px solid #f7f7f7;
        cursor: pointer;
        .stext{
            margin-right: 10px;
        }
        .stext.renter{
            width: 100px;
            display: inline-block;
        }
        &:hover{
            background: #f7f7f7;
        }
        &:active{
            background: #eee;
        }
    }
}

</style>